import Container from 'components/Container';
import ProductRail from 'components/ProductRail';
import SectionHeader from 'components/SectionHeader';

export default function ProductRailBlock({ block }) {
  const id = `blk-${block.id}`;
  return (
    <section aria-labelledby={id} className="py-12 lg:py-16">
      <Container>
        <SectionHeader id={id} eyebrow={block.eyebrow} title={block.title} intro={block.intro} link={block.link} />
        <ProductRail products={block.products} label={block.title} className="mt-8" />
      </Container>
    </section>
  );
}
